import React from 'react';
import { Grid, GridSize } from '@material-ui/core';
import PostItem from './PostItem';

export interface Props {
  posts: Post[];
  featuredSize: number;
  postColumn: number;
  type: postTypes;
}

const PostGroup: React.FC<Props> = ({
  posts,
  featuredSize,
  postColumn,
  type,
}) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={featuredSize as GridSize}>
        <PostItem post={posts[0]} imageHeight={278} hideDetail type={type} />
      </Grid>
      {posts.length > 1 && (
        <Grid item xs={12} md={(12 - featuredSize) as GridSize}>
          <Grid container spacing={1}>
            {posts.slice(1).map((post, index) => (
              <Grid item key={index} xs={12} md={(12 / postColumn) as GridSize}>
                <PostItem
                  post={post}
                  imageHeight={100}
                  hideDetail
                  type={type}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default PostGroup;
